import './StageCard.css';

export default function StageCard({ stage, onEdit, onDelete, isDragging, dragOver, onDragStart, onDragOver, onDrop, onDragEnd }) {
  const checklistCount = stage.checklist?.length || 0;
  const requiredCount = stage.checklist?.filter(item => item.required).length || 0;
  const coverage = Math.min(1, requiredCount / Math.max(1, stage.checklist?.length || 1));
  const circumference = 2 * Math.PI * 15;
  const dashOffset = circumference * (1 - coverage);

  return (
    <div
      className={`stage-card ${isDragging ? 'stage-card--dragging' : ''} ${dragOver ? 'stage-card--drag-over' : ''}`}
      draggable={true}
      onDragStart={onDragStart}
      onDragOver={e => { e.preventDefault(); onDragOver(); }}
      onDrop={onDrop}
      onDragEnd={onDragEnd}
    >
      <div className="stage-card__grip">{'\u2807'}</div>
      <div className="stage-card__stripe" style={{ background: stage.color || 'var(--color-primary)' }}></div>
      <div className="stage-card__icon">{stage.icon || '\uD83D\uDCCC'}</div>

      <div className="stage-card__content">
        <div className="stage-card__name">{stage.name}</div>
        {stage.description && <div className="stage-card__desc">{stage.description}</div>}
        {(stage.sub_stages?.length > 0 || stage.doc_requirements?.length > 0) && (
          <div className="stage-card__meta">
            {stage.sub_stages?.map((ss, i) => <div key={i} className="stage-card__chip">{ss}</div>)}
            {stage.doc_requirements?.map((dr, i) => <div key={i} className="stage-card__chip">&#128196; {dr}</div>)}
          </div>
        )}
      </div>

      <div className="stage-card__ring">
        <svg width="36" height="36" viewBox="0 0 36 36" style={{ transform: 'rotate(-90deg)' }}>
          <circle cx="18" cy="18" r="15" fill="none" stroke="var(--color-border)" strokeWidth="2" />
          <circle
            cx="18" cy="18" r="15"
            fill="none"
            stroke={stage.color || 'var(--color-primary)'}
            strokeWidth="2"
            strokeDasharray={circumference}
            strokeDashoffset={dashOffset}
            strokeLinecap="round"
            style={{ transition: 'stroke-dashoffset 0.4s ease' }}
          />
          <text x="18" y="21" textAnchor="middle" fontSize="10" fontFamily="var(--font-main)" fontWeight="700" fill="var(--color-text)" style={{ transform: 'rotate(90deg)', transformOrigin: '18px 18px' }}>
            {checklistCount}
          </text>
        </svg>
      </div>

      <div className="stage-card__actions">
        <button className="stage-card__btn stage-card__btn--edit" onClick={() => onEdit(stage)}>&#9998; Edit</button>
        <button className="stage-card__btn stage-card__btn--delete" onClick={() => onDelete(stage.uid)}>&#10005; Delete</button>
      </div>
    </div>
  );
}
